<template>
    <div class="dashboard">
        <div class="columns is-multiline">
            <transition name="fade">
                <div v-show="showWelcomeInfo" class="column is-full">
                    <welcome-info></welcome-info>
                </div>
            </transition>
            <div class="column is-full">
                <div class="title-and-icon-info">
                    <div class="icon-info"><font-awesome-icon :icon="['far', 'chart-bar']"/></div>
                    <div class="title-info">Overview</div>
                </div>
                <div class="cloudlets-general-stats">
                    <div class="columns">
                        <div class="column is-3">
                            <cloudlets-gauge></cloudlets-gauge>
                        </div>
                        <div class="column is-6" style="padding-right: 60px;">
                            <snapshots-size-chart></snapshots-size-chart>
                        </div>
                        <div class="column is-3">
                            <snapshots-stats></snapshots-stats>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-half">
                <div class="title-and-icon-info">
                    <div class="icon-info"><font-awesome-icon icon="list-ul"/></div>
                    <div class="title-info">Your last snapshots & backups</div>
                </div>
                <last-snapshots></last-snapshots>
                <!-- <general-activity></general-activity> -->
            </div>
            <div class="column is-6">
                <div class="columns is-multiline">
                    <div class="column is-full">
                        <div class="title-and-icon-info">
                            <div class="icon-info"><font-awesome-icon :icon="['far', 'lightbulb']"/></div>
                            <div class="title-info">Snapshots & backups averages</div>
                        </div>
                        <snapshots-averages days="7"></snapshots-averages>
                    </div>
                    <div class="column is-full">
                        <snapshots-averages days="30"></snapshots-averages>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CloudletsGauge from '@/components/Dashboard/CloudletsGauge.vue';
import SnapshotsStats from '@/components/Dashboard/SnapshotsStats.vue';
import SnapshotsSizeChart from '@/components/Dashboard/SnapshotsSizeChart.vue';
// import GeneralActivity from '@/components/Dashboard/GeneralActivity.vue';
import LastSnapshots from '@/components/Dashboard/LastSnapshots.vue';
import SnapshotsAverages from '@/components/Dashboard/SnapshotsAverages.vue';
import WelcomeInfo from '@/components/Dashboard/WelcomeInfo.vue';
// import AccountsList from '@/components/Accounts/List.vue';
// import Api from '@/api';

export default {
    name: 'dashboard',

    metaInfo: {
        title: 'Dashboard - Weap.io',
    },

    data() {
        return {
            showWelcomeInfo: false,
        }
    },

    components: {
        // AccountsList,
        CloudletsGauge,
        SnapshotsStats,
        SnapshotsSizeChart,
        // GeneralActivity,
        LastSnapshots,
        SnapshotsAverages,
        WelcomeInfo,
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        listenEvents() {
            let vm = this;

            Event.$on('showWelcomeInfo', () => {
                vm.showWelcomeInfo = true;
            });

            Event.$on('hideWelcomeInfo', () => {
                vm.showWelcomeInfo = false;
            });
        },
    },

    computed: {
        //
    },
}
</script>

<style>
.fade-enter-active {
    transition: opacity 1s;
}
.fade-leave-active {
    transition: opacity .5s;
}
</style>